import React, { forwardRef, HTMLAttributes, ReactNode } from 'react';
import cn from 'classnames';

import styles from './model-row.module.scss';

interface ModelRowProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
}

export const ModelRow = forwardRef<HTMLDivElement, ModelRowProps>(function ModelRow(
    { children, className, ...props },
    ref,
) {
    return (
        <div {...props} className={cn(styles.box, className)} ref={ref}>
            {children}
        </div>
    );
});
